import { EpiContent, EpiContentBlock } from '@api/types';
import { BlockContainer, ContentArea, Title, USPItem, USPList } from '@components';
import { Box, styled } from '@mui/material';
import React from 'react';

// STYLES
//--------
const USPBlockWrapper = styled(Box)<USPBlockProps>``;

// TYPES
//-------
export type USPBlockProps = {
  title?: string;
  children?: React.ReactNode;
  content?: EpiContent;
  titleAlign?: 'left' | 'center' | 'right';
};

// COMPONENTS
//------------
export const USPBlock = ({ children, title, content = [], titleAlign }: USPBlockProps) => {
  const normalizedContent = Array.isArray(content) ? content : [content];
  const itemCount = normalizedContent.length;
  const loadingComponent = (
    <>
      {Array(itemCount)
        .fill('')
        .map((_, key) => (
          <USPItem isLoading={true} key={key} />
        ))}
    </>
  );
  return (
    <BlockContainer>
      <USPBlockWrapper className='usp-block'>
        {title && (
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Title
              variant='h2'
              sx={{
                textAlign: titleAlign || 'center',
              }}
            >
              {title}
            </Title>
          </Box>
        )}
        {children}
        {content && (
          <USPList itemCount={itemCount}>
            <ContentArea
              content={content}
              wrapperComponent={(props) => (
                <USPBlockChildItemMapper {...props} itemCount={itemCount} />
              )}
              loadingComponent={loadingComponent}
            />
          </USPList>
        )}
      </USPBlockWrapper>
    </BlockContainer>
  );
};

export type USPBlockChildItemMapperProps = {
  block?: EpiContentBlock;
  itemCount: number;
};

// COMPONENTS
//------------

/**
 * Map content block to USP Item
 */
export const USPBlockChildItemMapper = ({
  block = {},
  itemCount,
}: USPBlockChildItemMapperProps) => {
  return (
    <USPItem
      image={block.image}
      text={block.text}
      title={block.title}
      cardBackgroundColor={block.cardBackgroundColor}
      textColor={block.textColor}
      imageConfig={block.imageConfig}
      itemCount={itemCount}
      textAlign={block.textAlign}
    />
  );
};
